<div id="palette-scale-container">
<canvas class="palette_base"></canvas>
<ng-container #vc>
    <svg id="scratch_svg">
    
    </svg>
    
</ng-container>
</div>
